<template>
  <div>
    <div class="tw-py-2 sm:tw-py-0 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-if="isEditing">
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light tw-flex tw-items-center">Full Name</dt>
      <div class="tw-flex tw-items-center sm:tw-pt-4 sm:tw-col-span-2">
        <base-form ref="form" class="tw-w-full ">
          <base-text-field placeholder="Enter Full Name" v-model="fullName" required />
        </base-form>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse sm:tw-items-center">
        <base-button size="sm" @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button size="sm" type="flat" @click="isEditing = false" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">Cancel</base-button>
      </div>
    </div>
    <div class="tw-py-2 sm:tw-py-4 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-else>
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light">Full Name</dt>
      <dd class="tw-mt-1 tw-flex tw-text-sm tw-text-gray-900 sm:tw-mt-0 sm:tw-col-span-3 tw-mb-0">
        <span class="tw-flex-grow">{{ user.fullName }}</span>
        <span class="tw-ml-4 tw-flex-shrink-0">
          <base-button type="text" @click="startEditing">Update</base-button>
        </span>
      </dd>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEditing: false,
      isLoading: false,
      fullName: "",
    };
  },
  methods: {
    startEditing() {
      this.fullName = this.user.fullName;
      this.isEditing = true;
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      try {
        this.isLoading = true;
        const body = {
          ...this.user,
          fullName: this.fullName,
        };
        await this.$axios.put(`/users/${this.user.id}`, body);
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "User Profile Updated", message: "User info was saved successfully" });
        this.$emit("user-updated", body);
        this.isEditing = false;
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Issue updating profile",
          message: "We had an issue updating your profile. You may want to try again.",
          error: { message: error.response.data },
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler() {
        this.fullName = this.user.fullName;
      },
    },
  },
};
</script>
